module.exports = __webpack_public_path__ + "img/wv-logo-sm.910b3821.jpg";